module.exports = __webpack_public_path__ + "media/images/painting-can-collection-b7fe06da5480cd8c5c011e3e23b0a3da.jpg";